import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import './global-declaration';
import './index.scss';
import { store } from './redux/store';
import { DateTime } from 'luxon';

const container = document.getElementById('root');

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

window.formatDateTime = (
  dateTime: string,
  format: 'DATE_SHORT' | 'TIME_SIMPLE' | 'DATETIME_SHORT'
) => {
  /*
 * {
                      month: 'long',
                      day: 'numeric',
                      year: 'numeric',
                    }
 *
 * */
  return DateTime.fromISO(dateTime).toLocaleString(DateTime[format]);
};
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);
